import {useEffect, useState} from 'react';

import {classNames, noop} from '../../utils';

export const DatePicker = ({
                               min,
                               max,
                               name,
                               label,
                               value,
                               disabled,
                               type = 'date',
                               onChange = noop
                           }: {
    name: string;
    min?: string;
    max?: string;
    label: string;
    value?: string;
    disabled?: boolean;
    type?: 'date' | 'time' | 'datetime-local';
    onChange: (item: { [key: string]: string | number }) => void;
}) => {
    const [defaultMin, setDefaultMin] = useState<string>();
    const [defaultMax, setDefaultMax] = useState<string>();
    const [defaultValue, setDefaultValue] = useState<string>();

    const handleChange = (e: any) => {
        setDefaultValue(e.target.value);
    };

    const handleBlur = (e: any) => {
        onChange({[name]: e.target.value});
    };

    useEffect(() => {
        if (value) {
            if (type === 'date') {
                // const temp = new Date(value);
                // setDefaultValue(temp.toISOString().split('T')[0]);
                setDefaultValue(value);
            } else if (type === 'time') {
                setDefaultValue(value);
            } else {
                let temp: Date | string = new Date(value);

                setDefaultValue(
                    temp.toISOString().split('T').join(' ').split('.')[0]
                );
            }
        } else {
            setDefaultValue('');
        }
    }, [value]);

    useEffect(() => {
        if (type === 'date') {
            if (min) {
                const temp = new Date(min);

                setDefaultMin(temp.toISOString().split('T')[0]);
            }

            if (max) {
                const temp = new Date(max);

                setDefaultMax(temp.toISOString().split('T')[0]);
            }
        } else {
            if (min) {
                let temp: Date | string = new Date(min);

                setDefaultMin(
                    temp.toISOString().split('T').join(' ').split('.')[0]
                );
            }

            if (max) {
                let temp: Date | string = new Date(max);

                setDefaultMax(
                    temp.toISOString().split('T').join(' ').split('.')[0]
                );
            }
        }
    }, [min, max]);

    return (
        <div className="relative mb-[24px]">
            <label className="block text-sm font-semibold leading-6 text-gray-700">
                {label}
            </label>
            <input
                min={defaultMin}
                max={defaultMax}
                disabled={disabled}
                onChange={handleChange}
                onBlur={handleBlur}
                pattern="\d{4}-\d{2}-\d{2}"
                value={defaultValue}
                type={type}
                data-testid={`datepicker-${name}`}
                className={classNames(
                    'w-full h-[40px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent outline-0 border-0 border-b-2',
                    disabled
                        ? 'text-gray-darker bg-gray-light border-b-2 border-b-gray-dark'
                        : 'text-black bg-transparent border-b-2 border-b-black'
                )}
            />
        </div>
    );
};
